<template>
  <b-badge v-if="statusCode === 'active'" variant="primary">{{ statusName }}</b-badge>
  <b-badge v-else-if="statusCode === 'pending'" variant="info">{{ statusName }}</b-badge>
  <b-badge v-else-if="statusCode === 'expired'" variant="light">{{ statusName }}</b-badge>
  <b-badge v-else-if="statusCode === 'sold'" variant="success">{{ statusName }}</b-badge>
  <b-badge v-else-if="statusCode === 'lost'" variant="danger">{{ statusName }}</b-badge>
  <b-badge v-else-if="statusCode === 'cancelled'" variant="warning">{{ statusName }}</b-badge>
  <b-badge v-else variant="dark">{{ statusName }}</b-badge>
</template>

<script>
export default {
  name: "AdminListingStatusBadge",
  props: {
    listing: {
      type: Object,
      required: true
    }
  },
  computed: {
    statusCode() {
      return this.listing?.status?.code;
    },
    statusName() {
      return this.listing?.status?.name;
    }
  }
}
</script>